import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { BotService } from 'src/app/services/bot.service';


@Component({
  selector: 'app-top-exchanges',
  templateUrl: './top-exchanges.component.html',
  styleUrls: ['./top-exchanges.component.css']
})

export class TopExchangesComponent {
exchangePrices: any[] = [];
constructor(private http: HttpClient, private service: BotService) {}
intervalId: any;

ngOnInit() {
   //this.getBinancePrice('POL', 'USDT');
   this.intervalId = setInterval(() => this.fetchAllPrices(), 2000); 
  }
fetchAllPrices() {
 
  this.service.getArbitragePrice().subscribe(
    (res: any) => {
      const data = res?.result?.DATA || {};
      this.exchangePrices = Object.entries(data).map(([name, price]) => ({
        name,
        price
      }));
      console.log('All prices:', this.exchangePrices, res);
    },
    (error: any) => {
      console.error('Error fetching prices:', error);
    }
  );
}




//   async getBinancePrice(coin: string, tocoin: string) {
//     const res = await axios.get(`https://arbitrage.credbull.in/api/prices`);
//     return parseFloat(res.data);
//     console.log('Binance Price:', res.data,res);
//   }




//   async fetchAllPrices(coin: string, tocoin: string) {
//   const exchangeCalls = [ 
//     { name: 'Binance', fn: () => this.getBinancePrice(coin, tocoin) },
//     { name: 'BingX', fn: () => this.getBingxPrice(coin, tocoin) },
//     { name: 'Bitget', fn: () => this.getBitgetPrice(coin, tocoin) },
//     { name: 'Bitmart', fn: () => this.getBitmartPrice(coin, tocoin) },
//     { name: 'Bybit', fn: () => this.getBybitPrice(coin, tocoin) },
//     { name: 'Crypto.com', fn: () => this.getCryptocomPrice(coin, tocoin) },
//     { name: 'Gate.io', fn: () => this.getGateioPrice(coin, tocoin) },
//     { name: 'KuCoin', fn: () => this.getKucoinPrice(coin, tocoin) },
//     { name: 'MEXC', fn: () => this.getMexcPrice(coin, tocoin) },
//     { name: 'XT.com', fn: () => this.getXtPrice(coin, tocoin) },
//   ];
//   const results = await Promise.allSettled(
//     exchangeCalls.map(exchange => exchange.fn())
//   );
//   this.exchangePrices = results.map((result, index) => {
//     const { name } = exchangeCalls[index];
//     if (result.status === 'fulfilled') {
//       return { name, price: result.value };
//     } else {
//       console.error(` ${name} failed:`, result.reason);
//       return { name, price: null };
//     }
//   });
//   console.log('Exchange Prices:', this.exchangePrices);
// }

//   async getBinancedPrice(coin: string, tocoin: string) {
//     const res = await axios.get(`https://arbitrage.credbull.in/api/prices`);
//     return parseFloat(res.data);
//     console.log('Binance Price:', res.data,res);
//   }

//     async getBingxPrice(coin: string, tocoin: string) {
//       const symbol = `${coin.toUpperCase()}_${tocoin.toUpperCase()}`;
//       const res = await axios.get(`https://open-api.bingx.com/openApi/spot/v1/ticker/price?symbol=${symbol}`);
//       const data = res.data.data;
//      return parseFloat(data[0].trades[0].price);
//     }

//   async getBitgetPrice(coin: string, tocoin: string) {
//     const symbol = `${coin}${tocoin}`.toUpperCase();
//     const res = await axios.get(`https://api.bitget.com/api/v2/spot/market/tickers?symbol=${symbol}`);
//     return parseFloat(res.data.data[0].lastPr);
//   }

//   async getBitmartPrice(coin: string, tocoin: string) {
//     const symbol = `${coin}_${tocoin}`.toUpperCase();
//     const res = await axios.get(`https://api-cloud.bitmart.com/spot/quotation/v3/ticker?symbol=${symbol}`);
//     return parseFloat(res.data.data.last);
//    }

//   async getBybitPrice(coin: string, tocoin: string) {
//     const res = await axios.get('https://api.bybit.com/v5/market/tickers?category=spot');
//     const ticker = res.data.result.list.find((t: any) => t.symbol === `${coin}${tocoin}`);
//     return parseFloat(ticker?.lastPrice);
//   }

//   async getCryptocomPrice(coin: string, tocoin: string) {
//     const symbol = `${coin.toUpperCase()}_${tocoin.toUpperCase()}`;
//     const res = await axios.get(`https://api.crypto.com/v2/public/get-ticker?instrument_name=${symbol}`);
//     return parseFloat(res.data.result.data[0].a);
//   }

//   async getGateioPrice(coin: string, tocoin: string) {
//     const symbol = `${coin}_${tocoin}`.toLowerCase();
//     const res = await axios.get(`https://api.gateio.ws/api/v4/spot/tickers?currency_pair=${symbol}`);
//     return parseFloat(res.data[0].last);
//   }

//   async getKucoinPrice(coin: string, tocoin: string) {
//     const res = await axios.get(`https://api.kucoin.com/api/v1/market/orderbook/level1?symbol=${coin}-${tocoin}`);
//     return parseFloat(res.data.data.price);
//   }

//   async getMexcPrice(coin: string, tocoin: string) {
//     const symbol = `${coin.toUpperCase()}${tocoin.toUpperCase()}`;
//     const res = await axios.get(`https://api.mexc.com/api/v3/ticker/price?symbol=${symbol}`);
//     return parseFloat(res.data.price);
//   }

//   async getXtPrice(coin: string, tocoin: string) {
//     const symbol = `${coin.toUpperCase()}_${tocoin.toUpperCase()}`;
//     const res = await axios.get(`https://sapi.xt.com/v4/public/ticker/24h?symbol=${symbol}`);
//     if (res.data?.rc === 0 && res.data?.result[0].c) {
//       return parseFloat(res.data.result[0].c);
//     } else {
//       console.error(`XT.com returned no price for ${symbol}`, res.data);
//       return null;
//     }
//   }

}